import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Paragraph from '@tiptap/extension-paragraph';
import StarterKit from '@tiptap/starter-kit';
import Document from '@tiptap/extension-document';
import Text from '@tiptap/extension-text';
import { CSSProperties } from 'react';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Color from '@tiptap/extension-color';
import TextStyle from '@tiptap/extension-text-style';
import FontSize from 'tiptap-extension-font-size';

const Extentions = {
  MINIMAL: [
    Document.extend({
      content: 'block',
    }),
    Text,
    Paragraph,
  ],
  EXTENDED: [
    StarterKit.configure({
      code: false,
      codeBlock: false,
      dropcursor: false,
      horizontalRule: false,
      heading: false,
    }),
    Link.configure({
      openOnClick: false,
      autolink: true,
    }),
    Underline,
    TextStyle,
    Color,
    FontSize,
    Bold.extend({
      renderHTML({ HTMLAttributes }) {
        return ['b', HTMLAttributes, 0];
      },
      parseHTML() {
        return [{ tag: 'b' }, { tag: 'strong' }];
      },
    }),
    Italic.extend({
      renderHTML({ HTMLAttributes }) {
        return ['i', HTMLAttributes, 0];
      },
      parseHTML() {
        return [{ tag: 'i' }, { tag: 'em' }];
      },
    }),
  ],
};

const TextAreaStyles: CSSProperties = {
  minHeight: 250,
};

const TextInputStyles: CSSProperties = {
  minHeight: 32,
};

const removeParagraphWrapper = (str: string) => str.replace(/<\/?p>/g, '').replaceAll('&nbsp;', ' ');

// eslint-disable-next-line import/prefer-default-export
export const TiptapS = {
  Extentions,
  removeParagraphWrapper,
  TextAreaStyles,
  TextInputStyles,
};
